import { random4Digit } from 'utils';
import {
  VERIFY_PHONE_REQUEST,
  VERIFY_PHONE_SUCCESS,
  VERIFY_PHONE_ERROR,
  CLEAR_STATE_VERIFYING,
  SET_ISSUCCESS_VERIFYING,
  SET_IS_WRONG_CODE,
  SET_ISSUCCESS,
} from './constants';

export const verifyPhoneRequest = (number: string, field: string) => ({
  type: VERIFY_PHONE_REQUEST,
  payload: number,
  field,
  code: random4Digit(),
});

export const verifyPhoneSuccess = () => ({
  type: VERIFY_PHONE_SUCCESS,
});

export const verifyPhoneError = (message: string | null) => ({
  type: VERIFY_PHONE_ERROR,
  payload: message,
});

export const isSuccessFalse = (isSucessFalse: boolean) => ({
  type: SET_ISSUCCESS,
  payload: isSucessFalse,
});

export const isSucessVerify = (isSuccess: boolean) => ({
  type: SET_ISSUCCESS_VERIFYING,
  payload: isSuccess,
});

export const isErrorVerify = (isError: boolean) => ({
  type: SET_IS_WRONG_CODE,
  payload: isError,
});

export const clearStateVerify = () => ({
  type: CLEAR_STATE_VERIFYING,
});

export type Actions =
  | ReturnType<typeof isSucessVerify>
  | ReturnType<typeof isErrorVerify>
  | ReturnType<typeof verifyPhoneRequest>
  | ReturnType<typeof verifyPhoneSuccess>
  | ReturnType<typeof verifyPhoneError>
  | ReturnType<typeof isSuccessFalse>
  | ReturnType<typeof clearStateVerify>;
